
import { Link } from 'react-router-dom';

export default function CallToAction() {
  return (
    <section className="py-20 sm:py-28 lg:py-36 bg-gradient-to-b from-[#0A0A0A] via-[#0D1117] to-[#000000]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-gradient-to-r from-cyan-500/10 via-cyan-600/5 to-cyan-500/10 border border-cyan-500/30 rounded-3xl p-8 sm:p-12 lg:p-16 overflow-hidden">
          {/* Background Glow */}
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl"></div>

          <div className="relative z-10 text-center">
            <div className="inline-flex items-center gap-3 px-6 py-3 bg-black/50 backdrop-blur-sm border border-cyan-500/30 rounded-full mb-8">
              <i className="ri-puzzle-line text-xl text-cyan-400"></i>
              <span className="text-cyan-400 text-sm uppercase tracking-widest font-medium">Modular Innovation</span>
            </div>

            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6 text-white">
              Ready to Build <span className="text-cyan-400">Anywhere?</span>
            </h2>

            <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed">
              Our team specializes in bringing luxury living to impossible locations. 
              Let us help you realize your vision, no matter how remote.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                className="group inline-flex items-center gap-3 px-10 py-5 bg-cyan-500 text-black text-lg font-medium rounded-full hover:bg-cyan-400 transition-all hover:shadow-[0_0_40px_rgba(0,217,255,0.6)] whitespace-nowrap cursor-pointer"
              >
                Start Your Project
                <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center group-hover:shadow-lg transition-all">
                  <i className="ri-arrow-right-line text-cyan-400"></i>
                </div>
              </Link>
              <Link
                to="/product-range"
                className="group inline-flex items-center gap-3 px-10 py-5 bg-black/50 backdrop-blur-sm text-white text-lg font-medium rounded-full border border-cyan-500/30 hover:bg-cyan-500/10 hover:border-cyan-500/50 transition-all hover:shadow-[0_0_20px_rgba(0,217,255,0.3)] whitespace-nowrap cursor-pointer"
              >
                Compare All Series
                <i className="ri-compare-line text-xl text-cyan-400"></i>
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-light text-cyan-400 mb-2">50+</div>
                <div className="text-sm text-gray-400">Remote Installations</div>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-light text-cyan-400 mb-2">6</div>
                <div className="text-sm text-gray-400">Continents Reached</div>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-light text-cyan-400 mb-2">2-3</div>
                <div className="text-sm text-gray-400">Days Assembly</div>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-light text-cyan-400 mb-2">100%</div>
                <div className="text-sm text-gray-400">Satisfaction Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
